var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-2 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M14.223,4.653a.582.582,0,0,1-.6-.557V2.227a1.21,1.21,0,0,0-2.413,0V4.1A.605.605,0,0,1,10,4.1V2.227A2.328,2.328,0,0,1,12.413,0a2.328,2.328,0,0,1,2.413,2.227V4.1A.581.581,0,0,1,14.223,4.653Z",
    transform: "translate(1.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M12.723,24.826A4.228,4.228,0,0,1,8.5,20.6a.6.6,0,1,1,1.207,0,3.016,3.016,0,0,0,6.033,0,.6.6,0,1,1,1.207,0A4.228,4.228,0,0,1,12.723,24.826Z",
    transform: "translate(1.277 3.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M24.2,23.761H3.8A1.768,1.768,0,0,1,2,22.031a1.7,1.7,0,0,1,.63-1.315A7.9,7.9,0,0,0,5.6,14.578v-3.5A8.251,8.251,0,0,1,14,3a8.251,8.251,0,0,1,8.4,8.074v3.5a7.887,7.887,0,0,0,2.96,6.13A1.708,1.708,0,0,1,26,22.031,1.767,1.767,0,0,1,24.2,23.761ZM14,4.153a7.071,7.071,0,0,0-7.2,6.92v3.5a9.022,9.022,0,0,1-3.385,7.011.57.57,0,0,0-.215.442.589.589,0,0,0,.6.577H24.2a.589.589,0,0,0,.6-.577.568.568,0,0,0-.21-.438,9.029,9.029,0,0,1-3.39-7.015v-3.5A7.071,7.071,0,0,0,14,4.153Z",
    transform: "translate(0 0.62)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoti);
export default __webpack_public_path__ + "static/media/icon_noti.2fd5328fd28856386f61ce1dd19e8454.svg";
export { ForwardRef as ReactComponent };